export * from './game-reports.service';
import { GameReportsApiService } from './game-reports.service';
export * from './game-reports.serviceInterface';
export * from './group-reports.service';
import { GroupReportsApiService } from './group-reports.service';
export * from './group-reports.serviceInterface';
export * from './parent-reports.service';
import { ParentReportsApiService } from './parent-reports.service';
export * from './parent-reports.serviceInterface';
export * from './profile-copy-tokens.service';
import { ProfileCopyTokensApiService } from './profile-copy-tokens.service';
export * from './profile-copy-tokens.serviceInterface';
export * from './profile-qr-codes.service';
import { ProfileQrCodesApiService } from './profile-qr-codes.service';
export * from './profile-qr-codes.serviceInterface';
export * from './schema.service';
import { SchemaApiService } from './schema.service';
export * from './schema.serviceInterface';
export * from './stem-reports.service';
import { StemReportsApiService } from './stem-reports.service';
export * from './stem-reports.serviceInterface';
export * from './teacher-reports.service';
import { TeacherReportsApiService } from './teacher-reports.service';
export * from './teacher-reports.serviceInterface';
export const APIS = [GameReportsApiService, GroupReportsApiService, ParentReportsApiService, ProfileCopyTokensApiService, ProfileQrCodesApiService, SchemaApiService, StemReportsApiService, TeacherReportsApiService];
